/**
 * Side-effect-free tracker — must NOT import auth/store.
 * Federation shares `@/store/auth`; a cycle auth→screen-recorder→auth hangs `await M("vue")`.
 */

let lojaId = ''

export function trackAction(
    name: string,
    payload?: Record<string, string | number | boolean>,
): void {
    const sr = window.SessionRecorder
    if (!sr?.isActive()) {
        return
    }
    sr.trackAction(name, {
        ...(lojaId ? { loja_id: lojaId } : {}),
        ...payload,
    })
}

export function trackError(error: {
    message: string
    status?: number
    url?: string
    source?: string
}): void {
    const sr = window.SessionRecorder
    if (!sr?.isActive()) {
        return
    }
    sr.trackError(error)
}

export function setRecorderMetadados(metadados: Record<string, string>): void {
    if (metadados.loja_id) {
        lojaId = metadados.loja_id
    }
    const sr = window.SessionRecorder
    if (!sr?.isActive()) {
        return
    }
    sr.setMetadados(metadados)
}
